export default "__VITE_ASSET__BN2KSevi__"